// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"ContactsGrid_gridContainer__3wt-a","gridOverlay":"ContactsGrid_gridOverlay__1p2ch"};